export default __webpack_public_path__ + "static/media/game.fff53f4e.svg";